import { SortDescriptor } from "react-aria-components";

import { MODULE_VERSION_CONSUMERS_COLUMN_ID } from "./constants";
import { ModuleVersionConsumerRow } from "./types";

export const sortModuleVersionConsumers = (
  consumers: ModuleVersionConsumerRow[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return consumers;
  }

  const direction = sortDescriptor.direction === "ascending" ? 1 : -1;

  return [...consumers].sort((a, b) => {
    let valueA = "";
    let valueB = "";

    switch (sortDescriptor.column) {
      case MODULE_VERSION_CONSUMERS_COLUMN_ID.NAME:
        valueA = a.name;
        valueB = b.name;
        break;
      case MODULE_VERSION_CONSUMERS_COLUMN_ID.SPACE:
        valueA = a.space;
        valueB = b.space;
        break;
    }

    return valueA.localeCompare(valueB, undefined, { numeric: true }) * direction;
  });
};
